import { defineHTMLForModal } from "./components/quickView/quickViewModal";
import { initTooltip } from "../components/toolTip";
import { loadLazyImages } from "../utilities/globalUtilities";
import { triggerInitWishlistTogglers } from "../wishlist/wishlist";

const base = require("./base");
const detail = require("./detail");
const quickViewTemplate = require("./components/quickViewTemplate");
const focusHelper = require("../components/focus");
const urlUtils = require("../search/urlUtils");
const scrollLock = require("../utilities/scrollLock");
const cartUtil = require("../components/cartUtil");
import { triggerSelectionOfOnlyColor } from "../product/detailsUtil";

import { BRAND_COL } from "../utilities/constants";

const $cache = {
    body: $("body")
};

/**
 * Generates the modal window on the first call.
 * @param {string} brandID
 */
function getModalHtmlElement(brandID) {
    if ($("#quick-view-modal").length !== 0) {
        $("#quick-view-modal").remove();
    }

    $cache.body.append(defineHTMLForModal(brandID));
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 * @param {Object} gtmData - object with gtm data to be sent to datalayer
 */
function fillModalElement(selectedValueUrl, gtmData) {
    const $quickViewModal = $("#quick-view-modal");
    const $quickViewModalBody = $quickViewModal.find(".modal-body");
    const isQuickViewOpened = $(".js-product-quickview").length > 0 && $(".js-product-quickview").is(":visible");
    const isCartPage = $(".cart-page").length > 0;
    $quickViewModal.spinner().start();

    $cache.body.trigger("quickview:beforeUpdate");
    $.ajax({
        url: selectedValueUrl,
        method: "GET",
        dataType: "json",
        success: function (response) {
            const qvInfo = response.data;
            if (qvInfo.redirectUrl) {
                window.location.href = qvInfo.redirectUrl;
            } else {

                $.ajax({
                    url: response.data.addToCartButtonURL,
                    method: "GET",
                    dataType: "html",
                    success: function (htmlResponse) {
                        const qvDetails = Object.assign({}, qvInfo, {
                            addToCartButton: htmlResponse,
                            gtmData
                        });

                        $.ajax({
                            url: response.data.addToFavoritesButtonURL,
                            method: "GET",
                            dataType: "html",
                            success: function (htmlResponse) {
                                const fvDetails = Object.assign({}, qvDetails, {
                                    addToFavoritesButton: htmlResponse
                                });

                                const quickViewHTML = quickViewTemplate.quickView(fvDetails);
                                let $productTile;

                                if (isQuickViewOpened) {
                                    $quickViewModalBody.html(quickViewHTML);
                                } else {
                                    $quickViewModalBody.empty();
                                    $quickViewModalBody.html(quickViewHTML);
                                    $quickViewModal.find(".modal-header .close").attr("aria-label", response.data.resources.closeButtonText);
                                    $quickViewModal.find(".modal-header .close").attr("title", response.data.resources.closeTooltipText);
                                    $quickViewModal.find(".modal-title").text(response.data.resources.enterDialogMessage);
                                    $quickViewModal.modal("show");
                                    cartUtil.updateCartSummaryModalClass(true);
                                }

                                loadLazyImages("#quick-view-modal");
                                triggerInitWishlistTogglers();

                                if (response && response.data && response.data.product && response.data.product.id) {
                                    $productTile = $(`.product-tile.pid-${response.data.product.id}`);
                                }

                                setTimeout(function () {
                                    //Init the product options - colors & sizes - if any of the option is not available it is disabled
                                    base.initProductOptionsEvents();
                                    initTooltip("#quick-view-modal");
                                }, 300);

                                const $addBtn = $quickViewModal.find(".js-add-to-cart-button");
                                const isOutOfStock = $addBtn.data("outofstock");
                                $quickViewModal.find(".js-product-quickview").toggleClass("product-out-of-stock", isOutOfStock);

                                if (isOutOfStock) {
                                    $productTile.find(".container-add-button-options").empty().append(qvDetails["addToCartButton"]);
                                }

                                if (isCartPage) {
                                    $quickViewModal.find(".modal-dialog").addClass("ct-cart--edit-quickview");
                                    $addBtn.text($addBtn.data("cart-quickview-txt"));
                                    $addBtn.removeClass("add-to-cart");
                                    $addBtn.addClass("update-cart-product-global");
                                    if (!$quickViewModal.attr("data-original-pid")) {
                                        $quickViewModal.attr("data-original-pid", $addBtn.data("pid"));
                                    }

                                    if ($(".ct-pdp--variation-wrapper").length === 0) {
                                        cartUtil.initQuickViewQtyInput($addBtn);
                                        $quickViewModal.find(".modal-dialog").addClass("ct-cart--edit-quickview-standard");
                                    }
                                } else {
                                    cartUtil.initQuickViewQtyInput($addBtn);
                                }

                                $cache.body.trigger("quickview:afterUpdate");

                                //GTM datalayer logic - start

                                let productImpression = response.data.productImpression;
                                let position;
                                let list;
                                if (isCartPage) {
                                    const $cartLineItem = $(`[data-lid=${response.data.product.id}]`);
                                    list = $cartLineItem.parents(".gtm-list")?.data("gtm-list");
                                    position = $cartLineItem.closest("[data-product-tile-impression]")?.data("idx");
                                    $quickViewModalBody.find(".see-details").on("click", () => {
                                        document.dispatchEvent(new CustomEvent("dataLayer.CartClickImpression", {
                                            detail : {
                                                "productImpression" : productImpression
                                            }
                                        }));
                                    });
                                } else {
                                    list = $productTile.parents(".gtm-list")?.data("gtm-list");
                                    position = $productTile.parents(".pd-tile-wrap, .productTile").data("idx");
                                }

                                document.dispatchEvent(new CustomEvent("dataLayer.quickViewDetail", {
                                    detail: {
                                        "list": list,
                                        "productImpression": productImpression,
                                        "position": position
                                    }
                                }));
                                //GTM datalayer logic - end

                                $.spinner().stop();
                            },
                            error: function () {
                                $.spinner().stop();
                            },
                            complete: function () {
                                if ($(".pdp-images-carousel").is(":visible")) {
                                    detail.initPdpImagesCarousel();
                                }
                            }
                        });
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                    complete: function () {
                        if ($(".pdp-images-carousel").is(":visible")) {
                            detail.initPdpImagesCarousel();
                        }
                    }
                });
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

module.exports = {
    showQuickview: function () {
        $cache.body.off("click change", ".quickview, a.quickview, .js-quickview-sizes").on("click change", ".quickview, a.quickview, .js-quickview-sizes", function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const currentTarget = e.currentTarget;
            const eventType = e.type;

            if (eventType == "click" && currentTarget.className.includes("js-quickview-sizes")) {
                return;
            }

            const $this = $(this);
            const $miniCartPopOver = $(".minicart .popover");
            const $swatches = $this.parents(".swatches");
            const isQuickViewOpened = $(".js-product-quickview").length > 0 && $(".js-product-quickview").is(":visible");
            const $productTile = $this.closest(".product-tile");

            if ($this.hasClass("selectable")) {
                let quickViewURL = eventType === "change" ? $this.val() : ($this.hasClass("quickview") ? $this.attr("href") : $this.closest("a.quickview").attr("href"));
                if (quickViewURL.length <= 0) {
                    quickViewURL = eventType === "change" ? $this.attr("data-quickview-url") : ($this.hasClass("quickview") ? $this.attr("data-quickview-url") : $this.closest("a.quickview").attr("data-quickview-url"));
                }
                let pdpURL = eventType === "change" ? $this.attr("data-pdp-url") : ($this.hasClass("quickview") ? $this.attr("data-pdp-url") : $this.closest("a.quickview").attr("data-pdp-url"));
                let isWishlist = $this.data("iswishlist");

                if (isWishlist) {
                    quickViewURL = urlUtils.updateQueryParameter(quickViewURL, "iswishlist", true);
                    const isRecommendationPage = $(".ct-recommendations--product-carousels").length > 0;

                    if ($(".ct-user-dropdown--authenticated").length <= 0 && !isRecommendationPage) {
                        window.sessionStorage.setItem("wishlist-quickview-classname", $this[0].className);
                        window.sessionStorage.setItem("wishlist-quickview-pid", urlUtils.getURLParameter(quickViewURL, "pid"));
                        const url = document.querySelector(".highlight-context").getAttribute("href");
                        window.sessionStorage.setItem("url-after-login", window.location.href);
                        if (url) {
                            window.location.href = url;
                        }
                        return;
                    }
                }

                if ($miniCartPopOver.length && !$swatches.length) {
                    const productQtyMap = $miniCartPopOver.data("productqtymap");
                    const pid = urlUtils.getURLParameter(quickViewURL, "pid");

                    if (pid && "items" in productQtyMap && productQtyMap.items.length) {
                        productQtyMap.items.forEach(item => {
                            if (item.masterID == pid) {
                                quickViewURL = urlUtils.updateQueryParameter(quickViewURL, "pid", item.id);
                                pdpURL = urlUtils.updateQueryParameter(pdpURL, "pid", item.id);
                            }
                        });
                    }
                }

                if ($productTile.length > 0 && window.mqRespond.status.mobile) {
                    window.location.href = pdpURL;
                } else {
                    const selectedID = cartUtil.getSelectedProductIDForQuickview($this);
                    let selectedValueUrl = quickViewURL;

                    if (selectedID) {
                        const displayMasterInQV = cartUtil.checkIfProductMasterToDisplay($this);
                        if (!displayMasterInQV) {
                            selectedValueUrl = urlUtils.updateQueryParameter(quickViewURL, "pid", selectedID);
                        }
                    }

                    const list = $(this).closest(".gtm-list").data("gtm-list");
                    const gtmData = cartUtil.getGTMData($this, list);
                    
                    if (isQuickViewOpened) {
                        const isCartPage = $(".js-cart-page").length > 0;
                        if (isCartPage) {
                            let searchParams = new URLSearchParams(selectedValueUrl);
                            searchParams.set("brandID", BRAND_COL);
                            selectedValueUrl = decodeURIComponent(searchParams.toString());
                        }
                        fillModalElement(selectedValueUrl, gtmData);
                    } else {
                        $(e.target).trigger("quickview:show");
                        $.spinner().start();
                        getModalHtmlElement($this.attr("data-quickview-brand-id"));
                        fillModalElement(selectedValueUrl, gtmData);
                    }
                }
            }
        });
    },
    trapQuickviewFocus: function () {
        $cache.body.on("keydown", "#quick-view-modal", function (e) {
            var focusParams = {
                event: e,
                containerSelector: "#quick-view-modal",
                firstElementSelector: ".full-pdp-link",
                lastElementSelector: ".add-to-cart-global",
                nextToLastElementSelector: ".modal-footer .quantity-select"
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },
    availability: base.availability,
    addToCart: base.addToCart,
    beforeUpdateAttribute: function () {
        $cache.body.on("product:beforeAttributeSelect", function () {
            $(".modal.show .modal-content").spinner().start();
        });
    },
    updateAttribute: function () {
        $cache.body.on("product:afterAttributeSelect", function (e, response) {
            if ($(".modal.show .product-quickview>.bundle-items").length) {
                $(".modal.show").find(response.container).data("pid", response.data.product.id);
                $(".modal.show").find(response.container)
                    .find(".product-id").text(response.data.product.id);
            } else if ($(".set-items").length) {
                response.container.find(".product-id").text(response.data.product.id);
            } else {
                $(".modal.show .product-quickview").data("pid", response.data.product.id);
                $(".modal.show .full-pdp-link")
                    .attr("href", response.data.product.adjustedSelectedProductUrl);
            }
        });
    },
    updateAddToCart: function () {
        $cache.body.on("product:updateAddToCart", function (e, response) {
            // update global add to cart (single products, bundles)
            var dialog = $(response.$productContainer)
                .closest(".quick-view-dialog");

            $(".add-to-cart-global", dialog).attr("disabled",
                !$(".global-availability", dialog).data("ready-to-order")
                || !$(".global-availability", dialog).data("available")
            );
        });
    },
    updateAvailability: function () {
        $cache.body.on("product:updateAvailability", function (e, response) {
            // bundle individual products
            $(".product-availability", response.$productContainer)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available)
                .find(".availability-msg")
                .empty()
                .html(response.message);


            var dialog = $(response.$productContainer)
                .closest(".quick-view-dialog");

            if ($(".product-availability", dialog).length) {
                // bundle all products
                var allAvailable = $(".product-availability", dialog).toArray()
                    .every(function (item) { return $(item).data("available"); });

                var allReady = $(".product-availability", dialog).toArray()
                    .every(function (item) { return $(item).data("ready-to-order"); });

                $(".global-availability", dialog)
                    .data("ready-to-order", allReady)
                    .data("available", allAvailable);

                $(".global-availability .availability-msg", dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $(".global-availability", dialog)
                    .data("ready-to-order", response.product.readyToOrder)
                    .data("available", response.product.available)
                    .find(".availability-msg")
                    .empty()
                    .html(response.message);
            }
        });
    },
    quickViewScrollLocks: () => {
        $cache.body.on("shown.bs.modal", "#quick-view-modal", () => {
            $cache.body.addClass("modal-open");
            scrollLock.enable(true);

            if (!$("#quick-view-modal").find(".pdp-images-carousel").hasClass(".slick-initialized")) {
                detail.initPdpImagesCarousel();
            }

            triggerSelectionOfOnlyColor();
        });

        $cache.body.on("hidden.bs.modal", "#quick-view-modal", () => {
            scrollLock.disable();
            cartUtil.updateCartSummaryModalClass(false);
        });
    }
};
